module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAOwwAADsMBx2+oZAAAABx0RVh0U29mdHdhcmUAQWRvYmUgRmlyZXdvcmtzIENTNui8sowAAAAWdEVYdENyZWF0aW9uIFRpbWUAMDYvMjkvMjBI86wyAAAAh0lEQVQ4jb2UyQ0AIQgAyVZkSfT/soPZj3xMXA7DkvhQYCKnAAIoMIGx7pUzFkMBMahJFW5QE5XtoQLfoQDzqAjCj76uQQXKynEF7tqmHaIfyIYYjiqbv3AdshUPQT3wF9xtx0e65O9UtBSvpd1aBqRlpFuWUNvabFv0egE9wdUUegHd4QrIC4B/IMf4PBxtAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/close.png
// module id = JA1j
// module chunks = 1